import { Panel } from "primereact/panel"
import AdditionalQuestion from "./AdditionalQuestion"
import {
  checkDisplayConditional,
  checkConditionalRender,
} from "../../utils/utils"
const AdditionalQuestionGroup = ({
  group,
  entity,
  disabled,
  errors,
  removeError,
  setEntity,
}) => {
  const containerStyle = () => {
    if (group?.alignment === 1) {
      return {}
    } else {
      return { display: "flex", gap: "10px" }
    }
  }
  return (
    <Panel
      header={group?.title}
      toggleable
      style={{ width: "100%", marginBottom: "1rem" }}
      collapsed={!group?.expanded}
    >
      <div style={containerStyle()}>
        {group?.additionalQuestions
          ?.sort((a, b) => {
            return a.number - b.number
          })
          // eslint-disable-next-line array-callback-return
          .map((a) => {
            if (
              checkConditionalRender(
                a.enabled,
                a.required,
                "additional",
                a.conditionalSource
              )
            ) {
              if (group.alignment === 1) {
                return (
                  <AdditionalQuestion
                    entity={entity}
                    disabled={disabled}
                    errors={errors}
                    number={a.number}
                    question={a}
                    removeError={removeError}
                    setEntity={setEntity}
                    alignment={1}
                  />
                )
              } else {
                return (
                  <AdditionalQuestion
                    entity={entity}
                    disabled={disabled}
                    errors={errors}
                    number={a.number}
                    question={a}
                    removeError={removeError}
                    setEntity={setEntity}
                    alignment={0}
                  />
                )
              }
            } else {
              if (checkDisplayConditional(a, entity)) {
                if (group.alignment === 1) {
                  return (
                    <AdditionalQuestion
                      entity={entity}
                      disabled={disabled}
                      errors={errors}
                      number={a.number}
                      question={a}
                      removeError={removeError}
                      setEntity={setEntity}
                      alignment={1}
                    />
                  )
                } else {
                  return (
                    <AdditionalQuestion
                      entity={entity}
                      disabled={disabled}
                      errors={errors}
                      number={a.number}
                      question={a}
                      removeError={removeError}
                      setEntity={setEntity}
                      alignment={0}
                    />
                  )
                }
              }
            }
          })}
      </div>
    </Panel>
  )
}
export default AdditionalQuestionGroup
